module.exports = __webpack_public_path__ + "img/woman_zombie.06641223.gif";